module.exports = __webpack_public_path__ + "img/ti.80ea61d8.png";